// @flow
import type {
  Action,
} from 'fc-flow-types/redux'

import {
  ADD_USER,
  EDIT_USERS,
  DELETE_USER,
  EDIT_BILLING_INFO,
} from './constants'

export function addUser (): Action<> {
  return {
    type: ADD_USER,
  }
}

export function editUsers (): Action<> {
  return {
    type: EDIT_USERS,
  }
}

export function deleteUser (): Action<> {
  return {
    type: DELETE_USER,
  }
}

export function editBillingInfo (): Action<> {
  return {
    type: EDIT_BILLING_INFO,
  }
}
